(function () {
  'use strict';

  var STORAGE_KEY = 'nr-radio-state';

  function getAudio() {
    return document.getElementById('nr-radio-audio');
  }

  function getConfig() {
    return window.__NR_RADIO__ || { tracks: [], seamless: false };
  }

  function isSeamless() {
    return !!getConfig().seamless;
  }

  function clearState() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function readState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeState(player) {
    if (!isSeamless()) return;
    try {
      var track = player.getTrack(player.trackIndex);
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          trackIndex: player.trackIndex,
          trackUrl: track && track.url ? track.url : '',
          currentTime: player.audio.currentTime || 0,
          isPlaying: !player.audio.paused,
          muted: player.audio.muted,
        })
      );
    } catch (e) {
      /* ignore */
    }
  }

  function NRRadio() {
    this.audio = getAudio();
    this.tracks = getConfig().tracks || [];
    this.trackIndex = 0;
    this.loadedTrackIndex = -1;
    this.powerBtn = null;
    this.volumeBtn = null;
    this.channelBtn = null;
    this.channelLabel = null;
    this.initialized = false;
  }

  NRRadio.prototype.bindControls = function () {
    this.powerBtn = document.querySelector('[data-nr-radio-power]');
    this.volumeBtn = document.querySelector('[data-nr-radio-volume]');
    this.channelBtn = document.querySelector('[data-nr-radio-channel]');
    this.channelLabel = document.querySelector('[data-nr-radio-channel-label]');

    if (!this.powerBtn || !this.volumeBtn || !this.channelBtn || !this.audio) {
      return false;
    }

    if (!this.powerBtn.dataset.nrRadioBound) {
      this.powerBtn.dataset.nrRadioBound = 'true';
      this.powerBtn.addEventListener('click', this.onPowerClick.bind(this));
    }

    if (!this.volumeBtn.dataset.nrRadioBound) {
      this.volumeBtn.dataset.nrRadioBound = 'true';
      this.volumeBtn.addEventListener('click', this.onVolumeClick.bind(this));
    }

    if (!this.channelBtn.dataset.nrRadioBound) {
      this.channelBtn.dataset.nrRadioBound = 'true';
      this.channelBtn.addEventListener('click', this.onChannelClick.bind(this));
    }

    if (!this.audio.dataset.nrRadioBound) {
      this.audio.dataset.nrRadioBound = 'true';
      this.audio.addEventListener('ended', this.onTrackEnded.bind(this));
      this.audio.addEventListener('play', this.syncUi.bind(this));
      this.audio.addEventListener('pause', this.syncUi.bind(this));
      this.audio.addEventListener('volumechange', this.syncUi.bind(this));
      this.audio.addEventListener('timeupdate', this.onTimeUpdate.bind(this));
      window.addEventListener('pagehide', this.onPageHide.bind(this));
      window.addEventListener('pageshow', this.onPageShow.bind(this));
    }

    return true;
  };

  NRRadio.prototype.onPageHide = function () {
    if (!isSeamless()) {
      this.audio.pause();
      clearState();
      return;
    }
    writeState(this);
  };

  NRRadio.prototype.onPageShow = function (event) {
    if (!isSeamless()) return;
    if (!event.persisted) return;
    var saved = readState();
    if (!saved || !saved.isPlaying) return;
    if (this.audio.paused) {
      this.play();
    }
    this.syncUi();
  };

  NRRadio.prototype.onTimeUpdate = function () {
    if (!isSeamless()) return;
    if (this._saveTimer) return;
    var self = this;
    this._saveTimer = window.setTimeout(function () {
      self._saveTimer = null;
      if (!self.audio.paused) {
        writeState(self);
      }
    }, 2000);
  };

  NRRadio.prototype.getTrack = function (index) {
    if (!this.tracks.length) return null;
    var i = ((index % this.tracks.length) + this.tracks.length) % this.tracks.length;
    return this.tracks[i];
  };

  NRRadio.prototype.loadTrack = function (index, seekTime) {
    var track = this.getTrack(index);
    if (!track || !track.url) return false;

    this.trackIndex = index;
    var shouldResume = seekTime != null ? seekTime : 0;

    if (this.loadedTrackIndex !== index || this.audio.src !== track.url) {
      this.audio.src = track.url;
      this.loadedTrackIndex = index;
    }

    var applySeek = function () {
      if (shouldResume > 0 && isFinite(shouldResume)) {
        try {
          this.audio.currentTime = shouldResume;
        } catch (e) {
          /* ignore seek errors before metadata */
        }
      }
      this.syncUi();
    }.bind(this);

    if (this.audio.readyState >= 1) {
      applySeek();
    } else {
      this.audio.addEventListener('loadedmetadata', applySeek, { once: true });
    }

    return true;
  };

  NRRadio.prototype.play = function () {
    var self = this;
    if (!this.tracks.length) return;

    if (this.loadedTrackIndex !== this.trackIndex || !this.audio.src) {
      this.loadTrack(this.trackIndex, 0);
    }

    this.audio.play().then(function () {
      self.syncUi();
      writeState(self);
    }).catch(function () {
      self.syncUi();
    });
  };

  NRRadio.prototype.pause = function () {
    this.audio.pause();
    this.syncUi();
    writeState(this);
  };

  NRRadio.prototype.onPowerClick = function () {
    if (!this.tracks.length) return;

    if (this.audio.paused) {
      if (this.loadedTrackIndex !== this.trackIndex || !this.audio.src) {
        this.loadTrack(this.trackIndex, this.audio.currentTime || 0);
      }
      this.play();
    } else {
      this.pause();
    }
  };

  NRRadio.prototype.onVolumeClick = function () {
    this.audio.muted = !this.audio.muted;
    this.syncUi();
    writeState(this);
  };

  NRRadio.prototype.onChannelClick = function () {
    if (!this.tracks.length) return;

    var wasPlaying = !this.audio.paused;
    this.trackIndex = (this.trackIndex + 1) % this.tracks.length;
    this.loadTrack(this.trackIndex, 0);

    if (wasPlaying) {
      this.play();
    } else {
      this.syncUi();
      writeState(this);
    }
  };

  NRRadio.prototype.onTrackEnded = function () {
    if (!this.tracks.length) return;

    this.trackIndex = (this.trackIndex + 1) % this.tracks.length;
    this.loadTrack(this.trackIndex, 0);
    this.play();
  };

  NRRadio.prototype.syncUi = function () {
    if (this.powerBtn) {
      var playing = !this.audio.paused;
      this.powerBtn.classList.toggle('is-active', playing);
      this.powerBtn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      this.powerBtn.setAttribute('aria-label', playing ? 'Pause radio' : 'Play radio');
    }

    if (this.volumeBtn) {
      var muted = this.audio.muted;
      this.volumeBtn.classList.toggle('is-muted', muted);
      this.volumeBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
      this.volumeBtn.setAttribute('aria-label', muted ? 'Unmute radio' : 'Mute radio');
    }

    if (this.channelLabel) {
      var channelNumber = this.tracks.length ? this.trackIndex + 1 : 0;
      this.channelLabel.textContent = channelNumber < 10 ? '0' + channelNumber : String(channelNumber);
    }
  };

  NRRadio.prototype.restore = function () {
    if (!isSeamless()) {
      this.syncUi();
      return;
    }

    var saved = readState();
    if (!saved || !this.tracks.length) {
      this.syncUi();
      return;
    }

    this.trackIndex = saved.trackIndex || 0;
    this.audio.muted = !!saved.muted;

    if (this.audio.dataset.nrRadioBootstrapped === 'true') {
      this.loadedTrackIndex = this.trackIndex;
      this.syncUi();
      return;
    }

    this.loadTrack(this.trackIndex, saved.currentTime || 0);

    if (saved.isPlaying) {
      this.play();
    } else {
      this.syncUi();
    }
  };

  NRRadio.prototype.init = function () {
    this.tracks = getConfig().tracks || [];
    if (!this.bindControls()) return;

    if (!this.initialized) {
      this.initialized = true;
      this.restore();
    } else {
      this.syncUi();
    }
  };

  function boot() {
    if (!window.NRRadio) {
      window.NRRadio = new NRRadio();
    } else {
      window.NRRadio.tracks = getConfig().tracks || [];
    }
    window.NRRadio.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
